import { buildApiCacheKey } from "./cache-key";

export type InvalidateEventPageCacheParams = {
  eventId: string;
  slug?: string | null;
  previousSlug?: string | null;
  localeCodes: string[];
};

async function safeDeleteCache(key: string): Promise<void> {
  try {
    const { getCacheClient } = await import("./index");
    await getCacheClient().delete(key);
  } catch {
    // Redis unavailable — TTL will self-heal.
  }
}

/**
 * Best-effort Redis invalidation for event-page cache entries.
 * Callers supply locale codes so this module stays free of DB dependencies.
 */
export async function invalidateEventPageCache(
  params: InvalidateEventPageCacheParams
): Promise<void> {
  const slugs = [params.slug, params.previousSlug].filter(Boolean) as string[];
  const keys = [
    ...params.localeCodes.map((locale) =>
      buildApiCacheKey("event-page", { eventId: params.eventId, locale })
    ),
    ...slugs.flatMap((slug) =>
      params.localeCodes.map((locale) =>
        buildApiCacheKey("event-page", { slug, locale })
      )
    ),
  ];

  await Promise.allSettled(keys.map((key) => safeDeleteCache(key)));
}
